module.exports = __webpack_public_path__ + "img/f_p1_sakurajk.550ada04.jpg";